// Dummy data hook for employee skill radar chart
export default function useEmployeeSkillRadarData() {
  return [
    { skill: 'JavaScript', level: 8 },
    { skill: 'Communication', level: 6 },
    { skill: 'Leadership', level: 7 },
    { skill: 'React', level: 9 },
    { skill: 'Teamwork', level: 8 },
  ];
}
